export const SMARTPHONE_MAX_WIDTH = 1024;
export const TABLET_MIN_WIDTH = SMARTPHONE_MAX_WIDTH + 1;
export const TABLET_MAX_WIDTH = 1440;
export const PC_MIN_WIDTH = TABLET_MAX_WIDTH + 1;
export const SMARTPHONE_HEADER_HEIGHT = 250;
export const OTHER_HEADER_HEIGHT = 170;
export const TABLE_ROW_HEIGHT = 80;
